import { MainState } from './types';

export const lastToolResult = (state: MainState) => state.lastToolResult;
export const termsAccepted = (state: MainState) => state.termsAccepted;
export const news = (state: MainState) => state.news;
export const verhogingen = (state: MainState) => state.verhogingen;
